/* SEO route policy (Phase B) — kebijakan index/noindex & canonical per route
   untuk storefront tenant. Terpusat agar tidak tersebar per halaman.
   Prioritas robots: route policy (noindex) > page override > SEO global tenant. */

const NOINDEX_PREFIXES = [
  "/login", "/register", "/forgot-password", "/reset-password", "/accept-invitation",
  "/admin", "/checkout", "/profile", "/pesanan", "/cart", "/wishlist",
];

const _matches = (pathname, prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`);

export function routeRobots(pathname) {
  const p = (pathname || "/").replace(/\/+$/, "") || "/";
  return NOINDEX_PREFIXES.some((pre) => _matches(p, pre)) ? "noindex,nofollow" : null;
}

/* Query yang boleh dipertahankan di canonical, per route. Hanya `category`
   (slug valid) untuk /katalog; search/sort/harga/featured dst. dibuang (Fase C). */
const CANONICAL_QUERY = { "/katalog": { category: /^[a-z0-9]+(?:-[a-z0-9]+)*$/ } };

export function canonicalPathWithQuery(pathname, search) {
  const p = (pathname || "/").replace(/\/+$/, "") || "/";
  const allowed = CANONICAL_QUERY[p];
  if (!allowed || !search) return p;
  const params = new URLSearchParams(search);
  const kept = new URLSearchParams();
  Object.keys(allowed).forEach((k) => {
    const v = params.get(k);
    if (v && allowed[k].test(v)) kept.set(k, v);
  });
  const qs = kept.toString();
  return qs ? `${p}?${qs}` : p;
}

/* Fase C — /katalog?search= adalah ruang URL tak terbatas → noindex,follow
   (canonical tetap ke katalog bersih). sort/min_price/max_price/featured/
   bestseller tidak noindex; cukup dikonsolidasikan lewat canonical bersih. */
export function catalogQueryRobots(pathname, search) {
  const p = (pathname || "/").replace(/\/+$/, "") || "/";
  if (p !== "/katalog" || !search) return null;
  const q = new URLSearchParams(search).get("search");
  return q && q.trim() ? "noindex,follow" : null;
}
